import defaultJdQueueConfig from './default';

let config;

try {
  const loadedConfig = require('./' + process.env.REACT_APP_PROJECT_NAME + '-jdqueue-config');
  config = loadedConfig?.default ?? loadedConfig;
} catch (e) {
  if (defaultJdQueueConfig && typeof defaultJdQueueConfig === 'object') {
    config = defaultJdQueueConfig;
  } else {
    config = {};
  }
}

export default config;
